import { useMemo } from 'react';

const useFilterDisplay = ({
  outputCurrencies,
  availableFilters,
  hideBudgetOnMultiCurrency,
  redemptionUnit,
  priceFormat
}) => {
  const display = useMemo(() => {
    if (!availableFilters) {
      return [];
    }
    if (
      (hideBudgetOnMultiCurrency && outputCurrencies?.length !== 1) ||
      availableFilters.includes('Currency')
    ) {
      if (
        (availableFilters.includes('RedemptionUnit') &&
          (redemptionUnit.value === 'MILES' || redemptionUnit.value === 'POINTS')) ||
        outputCurrencies.length === 1 ||
        priceFormat.currencyCode
      ) {
        return availableFilters.filter((f) => f !== 'Currency');
      } else {
        return availableFilters.filter((f) => f !== 'Budget');
      }
    }
    return availableFilters;
  }, [availableFilters, outputCurrencies, hideBudgetOnMultiCurrency, redemptionUnit, priceFormat]);

  return display;
};

export default useFilterDisplay;
